<wm-data-entity-view
  *ngIf="dataEntity"
  [entity]="dataEntity"
  [form]="form"
  [applicationId]="applicationId"
  [activity]="activity"
  #selectContractor
>
</wm-data-entity-view>
